<template>
    <div class="content-card mb-4">
        <div class="content-card-title d-flex justify-content-between">
            <span class="d-flex align-items-center">
                <i class="flag-icon flag-icon-th me-2"></i>{{ $t("lotto_thai") }}
            </span>
            <span class="d-flex align-items-center text-primary">
               {{
           info.lottoDate ? dateParse(info.lottoDate) : ""
        }}
            </span>
        </div>
        <!-- {{ info }} -->
        <div class="content-card-body p-0">
            <div class="data-row d-flex justify-content-between">
                <span>รางวัลที่ 1</span>
                <strong class="text-dark">{{ info.first_prize ? info.first_prize : '' }}</strong>
            </div>
            <div class="data-row d-flex justify-content-between">
                <span>สี่ตัวบน</span>
                <strong class="text-dark">{{ info.fourDigit ? info.fourDigit : '' }}</strong>
            </div>
            <div class="data-row d-flex justify-content-between">
                <span>สามตัวบน</span>
                <strong class="text-dark">{{ info.prefixThreeDigit ? info.prefixThreeDigit : '' }}</strong>
            </div>
            <div class="data-row d-flex justify-content-between">
                <span>สามตัวล่าง</span>
                <strong class="text-dark">{{ info.suffixThreeDigit ? info.suffixThreeDigit : '' }}</strong>
            </div>
            <div class="data-row d-flex justify-content-between border-0">
                <span>สองตัวล่าง</span>
                <strong class="text-dark">{{ info.twoDigit ? info.twoDigit : '' }}</strong>
            </div>
        </div>
    </div>
</template>
<script>
import { format } from 'date-fns'
export default {
  props: {
    info: {
      type: Object,
      defaults: {
        lottoDate: '',
        twoDigit: '',
        suffixThreeDigit: '',
        prefixThreeDigit: '',
        first_prize: ''
      }
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    dateParse (date) {
      return format(Date.parse(date), 'dd MMMM yyyy')
    }
  }
}
</script>
